import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledResendQGConfirmationEmail = styled.div`
  .cta-container {
    display: flex;
    gap: ${toRem(20)};
    justify-content: flex-end;
  }
`;
